import axios from 'axios'
import qs from 'qs'
import { Message, Loading } from 'element-ui';
import router from "../router"; // 引入路由
import store from "../store" // 引入vuex
import Vue from 'vue'


// 浏览器指纹
import FingerprintJS from '@fingerprintjs/fingerprintjs'
let Fingerprint = ''
// 获取浏览器指纹
FingerprintJS.load().then(fp => {
  fp.get().then(result => {
    Fingerprint = result.visitorId;
  });
});

// console.log( Vue.prototype.$i18n);Vue.prototype.$i18n.locale == "zh" ? "": "進行中" 
let options = { text: '正在加载，请稍等...' }; // 接口发送请求时 显示的文字 
let loadingInstance
// axios.defaults.withCredentials = true; // cookies是否发送
// function getFormData(object) {
//   if (object) {
//     const formData = new FormData();
//     Object.keys(object).forEach(key => {
//       const value = object[key];
//       if (Array.isArray(value)) {
//         value.forEach((subValue, i) => {
//           formData.append(key + `[${i}]`, subValue)
//         })
//       } else {
//         formData.append(key, object[key])
//       }
//     })
//     console.log(formData);
//     return formData;
//   }
//   return object
// }

axios.interceptors.request.use(

  config => {
    // console.log(location.host.indexOf('.co.jp') === -1 ,location.host);
    // 获取token 添加headers发送请求
    let token = localStorage.getItem('japan_access_token')
    if (token) {
      config.headers['AdminToken'] = 'Bearer ' + token
      config.headers['Fingerprint'] = Fingerprint
      config.headers['PageUrlTrace'] = location.href
    }
    if (config.data) {
      if (config.data.XYT) {
        config.headers['RequestApi'] = config.data.XYT
        config.headers['Solution'] = 'XYT'
        delete config.data.XYT
      }
    }
    // 转为formdata数据格式
    config.data = qs.stringify(config.data)

    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    return config;
  },
  error => {
    return Promise.reject(error);
  });

// 添加响应拦截器(**具体查看axios文档**)----------------------------------------------------------------
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么，允许在数据返回客户端前，修改响应的数据
  // 如果是文件流(blob)，则返回完整的response对象，否则返回response.data
  if (response.config.responseType === 'blob') {
    return response
  }
  return response.data
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

// 封装数据返回失败提示函数---------------------------------------------------------------------------
function errorState(response) {
  // 隐藏loading
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400 || response.status === 500)) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    return response
  } else {
    if (loadingInstance) loadingInstance.close(); // 发送请求是结束
    Message.error('数据获取错误')
  }
}

// 封装数据返回成功提示函数---------------------------------------------------------------------------
function successState(res) {

  // 隐藏loading
  //统一判断后端返回的错误码(错误码与后台协商而定)
  if (loadingInstance) loadingInstance.close(); // 发送请求是结束
  if (res.code == 0 || res.code == 10003 || res.code == 10004) {
    return true
  }
  else if (res.code == 10000) { //接口错误
    Message.error(res.msg)
    return false

  } else if (res.code == 10001) { // 登录过期
    localStorage.removeItem('access_token')
    localStorage.removeItem('userRoleInfo')
    Message.error(res.msg)
    if (router.history.current.name != 'login') {
      router.push('/login')
    }

  } else if (res.code == 10002) { // 无权限
    if (router.history.current.matched.length == 1) {
      setTimeout(() => {
        window.open("about:blank", "_top").close();
      }, 3000)
    } else {
      router.push('/')
    }
    Message.error(res.msg)
  } else {
    return true
  }
  // 如有错误的消息提示，弹出消息提示
  if (res.message) {
    return Message.error(res.message)
  }

}

// 封装axios--------------------------------------------------------------------------------------
export function apiAxios(method, url, params, config = {}) {
  // 判断config是否为布尔值（兼容旧的isLoading参数）
  const isLoading = typeof config === 'boolean' ? config : config.isLoading;

  if (!isLoading) {
    loadingInstance = Loading.service(options); // 发送请求是开始
  }

  let httpDefault = {
    method: method, // 请求方式
    // baseURL: process.env.NODE_ENV !== "development" ? 'https://admin.rakumart.com' : '/api', // 默认请求地址 可能需要统一做跨域
    url: url,
    // `params` 是即将与请求一起发送的 URL 参数 `data` 是作为请求主体被发送的数据
    params: method === 'get' || method === 'DELETE' ? params : null,
    // data: method === 'POST' ? qs.stringify(params) : null || method === 'PUT' ? qs.stringify(params) : null,
    data: params,
    timeout: 100000,
    ...(typeof config === 'object' ? config : {}) // 合并配置对象
  }
  // 注意**Promise**使用(Promise首字母大写)
  return new Promise((resolve, reject) => {
    axios(httpDefault)
      // 此处的.then属于axios
      .then((res) => {
        let flag = successState(res)
        // 请求正常return
        if (flag || config.resolveError) {
          resolve(res)
        }

      }).catch((response) => {
        errorState(response)
        reject(response)
      })
  })
}





